export default function parseAsDate(date: any) {
  if (
    date &&
    (new Date(date) as any) !== 'Invalid Date' &&
    !isNaN(new Date(date) as any)
  ) {
    return new Date(date);
  }
  return undefined;
}
